import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Observable } from 'rxjs';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { startWith, map } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
    selector: 'app-add-edit-proposal',
    templateUrl: './add-edit-proposal.component.html',
    styleUrls: ['./add-edit-proposal.component.scss'],
    standalone: false
})
export class AddEditProposalComponent implements OnInit {
  addProposalForm: FormGroup;
  type: string;
  id: number;
  valueProposal: any;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  departmentCtrl = new FormControl();
  filteredDepartments: Observable<string[]>;
  departments: any[];
  allDepartments: any[];
  @ViewChild('departmentInput') departmentInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  departmentsList: any[];
  fileIconOn: boolean;
  filesList: FileList = null;
  allFiles: any[];
  productId: any;
  isLoading = false;
  departmentError = false;
  user: User;

  constructor(public dialogRef: MatDialogRef<AddEditProposalComponent>,
              private dataService: DataService,
              public utils: UtilsService,
              private router: Router,
              private authService: AuthService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.type = data.type;
                this.user = this.authService.getUserData();
                this.id = data.id;
                this.fileIconOn = true;
                this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
                this.allFiles = new Array<any>();
                this.departments = new Array<string>();
                this.allDepartments = new Array<string>();
                if (this.type === 'Edit') {
                  this.getValueProposal();
                  this.departmentCtrl.disable();
                }
                this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
                  startWith(null),
                  map((product: string | null) => product ? this._filter(product) : this.allDepartments.slice()));
              }

    ngOnInit(): void {
      this.addProposalForm = new FormGroup({
        sales_senario: new FormControl(this.valueProposal ?  this.valueProposal.salesScenario : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
        product_value: new FormControl(this.valueProposal ?  this.valueProposal.productValue : null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
        link: new FormControl(this.valueProposal ?  this.valueProposal.path : null, [Validators.pattern(this.utils.urlReg)]),
        file: new FormControl({ value: this.valueProposal ?  this.valueProposal.fileName : null, disabled: true }),
      });

      this.getAllDepartments();
    }

    getAllDepartments() {
      this.isLoading = true;
      this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=' + '&ProductId=' + this.productId, true).then((data) => {
        if (data.statusCode === 200) {
          this.departmentsList = [];
          this.allDepartments = [];
          this.departmentsList = data.data.records;
          this.departmentsList.forEach((productData) => {
            this.allDepartments.push(productData);
          });
          this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
            startWith(null),
            map((product: string | null) => product ? this._filter(product) : this.allDepartments.slice()));
        }
        this.isLoading = false;
        });
    }

    getValueProposal() {
      this.dataService.get('product/valueProposals/RetrieveValueProposalById/' + this.productId + '/' + this.data.id).then((data) => {
        if (data.statusCode === 200) {
          this.valueProposal = data.data;
          this.departments.push(this.valueProposal.department);
          this.addProposalForm.controls.sales_senario.setValue(this.valueProposal.salesScenario);
          this.addProposalForm.controls.product_value.setValue(this.valueProposal.productValue);
        }
      });
    }

    toggleIcon(type: string) {
      if (type === 'link' && this.fileIconOn) {
        this.addProposalForm.get('link').setValue(null);
        this.fileIconOn = !this.fileIconOn;
      } else if (type === 'file' && !this.fileIconOn) {
        this.filesList = null;
        this.fileIconOn = !this.fileIconOn;
        this.addProposalForm.get('file').setValue('');
      }
    }

    closeDialog() {
      if (this.type === 'Edit') {
        if (this.allFiles.length ===  0) {
          if (this.valueProposal.supportMaterials.length ===  0) {
            this.dialogRef.close();
          } else {
            this.dialogRef.close();
          }
        } else {
            if (this.valueProposal.supportMaterials.length ===  0) {
              this.dialogRef.close();
            } else {
              if (this.addProposalForm.dirty) {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Warning',
                    type: 'Warn',
                    message: 'You will miss your information once you close',
                    buttonText: 'cancel',
                    numberOfButtons: 2,
                    seconButtonText: 'Ok'
                  }
                });
                dialogRef.afterClosed().subscribe((status) => {
                  if (status === 'Ok') {
                    this.dialogRef.close();
                  }
                });
              } else {
                this.dialogRef.close();
              }
            }
        }
      } else {
        if (this.addProposalForm.dirty) {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Warning',
              type: 'Warn',
              message: 'You will miss your information once you close',
              buttonText: 'cancel',
              numberOfButtons: 2,
              seconButtonText: 'Ok'
            }
          });
          dialogRef.afterClosed().subscribe((status) => {
            if (status === 'Ok') {
              this.dialogRef.close();
            }
          });
        } else {
          this.dialogRef.close();
        }
      }

    }

    deleteValueProposalMaterial(materialId: any, index: any) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Delete',
          page: 'supportMaterial',
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status) {
          if (status === 'accept') {
            this.dataService.delete('product/valueProposals/DeleteValueProposalMaterial/'
            + this.productId + '/' + this.valueProposal.id + '/' + materialId).then((data) => {
              if (data.statusCode === 200) {
                this.valueProposal.supportMaterials.splice(index, 1);
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Success',
                    type: 'Success',
                    closeDialogRef: true,
                    message: 'Material deleted successfully',
                    buttonText: 'Ok'
                  }
                });
              } else {
                const dialogRef = this.dialog.open(AlertDialogComponent, {
                  disableClose: true,
                  width: '400px',
                  data: {
                    title: 'Error',
                    type: 'Error',
                    message: 'Something went wrong, Please try again!',
                    buttonText: 'Ok'
                  }
                });
              }
            });
          }
        }
      });
    }

    forceDownload(blob, filename) {
      const a = document.createElement('a');
      a.download = filename;
      a.href = blob;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }

    downloadResource(url, filename) {
      if (!filename) {
        filename = url.split('\\').pop().split('/').pop();
      }
      fetch(url, {
          headers: new Headers({
            Origin: location.origin
          }),
          mode: 'no-cors'
        })
        .then(response => response.blob())
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          this.forceDownload(blobUrl, filename);
        })
        .catch(e => {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        });
    }

    downloadMyFile(url: any, fileName: string) {
      if (url) {
        this.downloadResource(url , fileName);
      }
    }

    addFileOrListToList() {
      if (this.fileIconOn) {
        if (this.filesList && this.filesList.length > 0) {
          this.allFiles.push({type: 4, file: this.filesList[0]});
        }
      } else {
        if (this.addProposalForm.controls.link.valid && this.addProposalForm.get('link').value) {
          this.allFiles.push({type: 2, file:  this.addProposalForm.get('link').value});
        } else {
          this.addProposalForm.controls.link.markAsTouched();
          return;
        }
      }
      this.addProposalForm.get('link').setValue(null);
      this.filesList = null;
      this.addProposalForm.get('file').setValue('');
      this.toggleIcon('file');
    }

    truncate(string: string) {
      if (string.length  > 32) {
        string = string.slice(0, 32) + '...';
      }
      return string;
    }

    deleteFromFileList(index: any) {
      this.allFiles.splice(index, 1);
    }

    previewImage(fileList: any) {
      this.filesList = fileList;
      let name = '';
      for (let index = 0; index < fileList.length; index++) {
        if (index === 0) {
          name = fileList[index].name;
        } else {
          name = name + ',' + fileList[index].name;
        }
      }
      this.addProposalForm.get('file').setValue(name);
    }

    add(event: MatChipInputEvent): void {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim()) {
        if (this.departments.includes(value.trim())) {
          this.departments.push({
            id: Math.random(),
            name: value.trim()
          });
        }
      }
      if (input) {
        input.value = '';
      }
      this.departmentCtrl.setValue(null);
    }

    remove(product: any, index: any): void {
      if (index >= 0) {
        this.departments.splice(index, 1);
      }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
      let productExist = false;
      for (let index = 0; index < this.departments.length; index++) {
        const element = this.departments[index];
        if (element.id === event.option.value.id) {
          productExist = true;
        }
      }
      if (!productExist) {
        this.departments.push(event.option.value);
      }
      this.departmentInput.nativeElement.value = '';
      this.departmentCtrl.setValue(null);
    }

    private _filter(value: any): any[] {
      return this.allDepartments.filter(product => product.name.toLowerCase().includes(value));
    }

    searchDepartment(event: any) {
      if (this.departmentInput.nativeElement.value === "") {
        this.departmentsList = [];
        this.allDepartments = [];
        this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
          startWith(null),
          map((department: string | null) => department ? this._filter(department) : this.allDepartments.slice()));
      } else {
      this.isLoading = true;
      this.dataService.get('department/RetrieveDepartmentsByName?searchKeyword=' +
      this.departmentInput.nativeElement.value + '&ProductId=' + this.productId, true).then((data) => {
          if (data.statusCode === 200) {
            this.departmentsList = [];
            this.allDepartments = [];
            this.departmentsList = data.data.records;
            this.departmentsList.forEach((departmentData) => {
              this.allDepartments.push(departmentData);
            });
          }
          this.filteredDepartments = this.departmentCtrl.valueChanges.pipe(
            startWith(null),
            map((product: string | null) => product ? this._filter(product) : this.allDepartments.slice()));
          this.isLoading = false;
        });
      }
    }

  onSubmit() {
    this.addProposalForm.markAllAsTouched();
    this.addFileOrListToList();
    if (this.departments.length === 0) {
      this.departmentError = true;
      return;
    }

    this.addProposalForm.get('link').setValue('https://link.link');
    if (this.addProposalForm.valid) {
      const departmentIds = [];
      for (let index = 0; index < this.departments.length; index++) {
        const element = this.departments[index];
        departmentIds.push(element.id);
      }
      if (this.type === 'Edit') {
        const payload = {
          productId: parseInt(this.productId.toString(), 10),
          valueId: this.id,
          salesScenario: this.addProposalForm.get('sales_senario').value,
          productValue: this.addProposalForm.get('product_value').value,
          department: departmentIds[0],
        };
        this.utils.showProgressDialog();
        this.dataService.put('product/valueProposals/UpdateValueProposal', payload, true).then((data) => {
          if (data.statusCode === 200) {
            if (this.allFiles.length > 0) {
              this.updateMaterial(payload, [this.id]);
            } else {
              this.dialogRef.close(payload);
              this.utils.closeProgressDialog();
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Value proposal updated successfully',
                  closeDialogRef: true,
                  buttonText: 'Ok'
                }
              });
            }
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      } else if (this.type === 'Add') {
        const payload = {
          productId: parseInt(this.productId.toString(), 10),
          salesScenario: this.addProposalForm.get('sales_senario').value,
          productValue: this.addProposalForm.get('product_value').value,
          departments: departmentIds,
        };
        this.utils.showProgressDialog();
        this.dataService.post('product/valueProposals/CreateValueProposal', payload, true).then((data) => {
          if (data.statusCode === 200) {
            const  valuesIds = [];
            for (let index = 0; index < data.data.length; index++) {
              const element = data.data[index];
              valuesIds.push(element.id);
            }
            this.updateMaterial(payload, valuesIds);
            for (let index = 0; index < data.data.length; index++) {
              const element = data.data[index];
            }
          } else if (data.statusCode === 403) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Please choose departments related to this product!',
                buttonText: 'Ok'
              }
            });
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
        this.utils.closeProgressDialog();
      }
    } else {
      this.addProposalForm.markAllAsTouched();
    }
  }
  updateMaterial(payload: any, valuesIds: any) {
    if (valuesIds.length === 1) {
      if (this.allFiles.length === 0) {
        this.dialogRef.close(payload);
        this.utils.closeProgressDialog();
      }
      for (let index = 0; index < this.allFiles.length; index++) {
        const element = this.allFiles[index];
        const filePayload = new FormData();
        filePayload.append('file', element.type === this.utils.supportMaterials.File ? element.file : null);
        filePayload.append('link', element.type === this.utils.supportMaterials.Link ? element.file : null);
        filePayload.append('valueId', valuesIds[0]);
        filePayload.append('productId', this.productId.toString());
        filePayload.append('type', element.type);
        this.dataService.put('product/valueProposals/UpdateValueProposalSupportMaterial', filePayload, true).then((mediaData) => {
          if (mediaData.statusCode === 200) {
          
            this.dialogRef.close(payload);
          } else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
      }

    } else {
      if (this.allFiles.length === 0) {
        this.dialogRef.close(payload);
        this.utils.closeProgressDialog();
      }
      for (let idIndex = 0; idIndex < valuesIds.length; idIndex++) {
        for (let index = 0; index < this.allFiles.length; index++) {
          const element = this.allFiles[index];
          const filePayload = new FormData();
          filePayload.append('file', element.type === this.utils.supportMaterials.File ? element.file : null);
          filePayload.append('link', element.type === this.utils.supportMaterials.Link ? element.file : null);
          filePayload.append('valueId', valuesIds[idIndex]);
          filePayload.append('productId', this.productId.toString());
          filePayload.append('type', element.type);
          this.dataService.put('product/valueProposals/UpdateValueProposalSupportMaterial', filePayload, true).then((mediaData) => {
            if (mediaData.statusCode === 200) {

              this.dialogRef.close(payload);
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }

      }

    }

    if (this.type === 'Add') {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Success',
          type: 'Success',
          message: 'Value proposal added successfully',
          closeDialogRef: true,
          buttonText: 'Ok'
        }
      });
    } else {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Success',
          type: 'Success',
          closeDialogRef: true,
          message: 'Value proposal updated successfully',
          buttonText: 'Ok'
        }
      });
    }

  }
}
